var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "xr-create",
    {
      attrs: { loading: _vm.loading, title: _vm.title },
      on: { close: _vm.close, save: _vm.saveClick },
    },
    [
      _c(
        "create-sections",
        { attrs: { title: "基本信息" } },
        [
          _c(
            "el-form",
            {
              ref: "crmForm",
              staticClass: "wk-form",
              attrs: {
                model: _vm.fieldForm,
                rules: _vm.fieldRules,
                "validate-on-rule-change": false,
                "label-position": "top",
              },
            },
            _vm._l(_vm.fieldList, function (children, index) {
              return _c("wk-form-items", {
                key: index,
                attrs: { "field-from": _vm.fieldForm, "field-list": children },
                on: { change: _vm.formChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ data }) {
                        return [
                          data && data.form_type == "customer"
                            ? _c("crm-relative-cell", {
                                attrs: {
                                  value: _vm.fieldForm[data.field],
                                  disabled: data.disabled,
                                  "relative-type": "customer",
                                },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          data &&
                          (data.form_type == "contract" ||
                            data.form_type == "contacts")
                            ? _c("crm-relative-cell", {
                                attrs: {
                                  value: _vm.fieldForm[data.field],
                                  disabled: data.disabled,
                                  relation: data.relation,
                                  "relative-type": data.form_type,
                                },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          data && data.form_type == "product"
                            ? _c("xh-product", {
                                attrs: { value: _vm.fieldForm[data.field] },
                                on: {
                                  "value-change": function ($event) {
                                    return _vm.otherChange($event, data)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }